import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useSearchParams } from '../../../../shared/lib/searchParams';
import { shutdownFiltersData } from '../../../../shared/constants';
import { useAddShutdonwAttachments } from '../../addAttachments';
import { useGenerateAlisaAudio } from '../../generateAlisaAudio';
import { useShutdownAlisaStateChange } from '../../changeAlisaState';

const {
  filters: { isNew, fromNotification },
} = shutdownFiltersData;

const createShutdown = async (values) => {
  const { files, enableAlisa, company, mainInitiator, ...restValues } = values;

  const data = await request.post(
    `/Alert`,
    restValues,
    'Не удалось создать отключение'
  );

  return data;
};

export const useCreateShutdown = (options = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { add: addAttachments } = useAddShutdonwAttachments();
  const { generateAudio } = useGenerateAlisaAudio();
  const { change: alisaStateChange } = useShutdownAlisaStateChange();

  const createMutation = useMutation(({ values }) => createShutdown(values), {
    ...options,
    onSuccess: async (data, { values }) => {
      if (data?.id) {
        const { files, alisaText, enableAlisa } = values;

        if (files) {
          await addAttachments({ shutdownId: data.id, files });
        }

        if (alisaText) {
          await generateAudio({
            shutdownId: data.id,
            text: alisaText,
          });
        }

        if (enableAlisa === true) {
          await alisaStateChange({ shutdownId: data.id, data: enableAlisa });
        }

        const newParams = new URLSearchParams(searchParams);
        newParams.set(isNew.name, data.id);
        newParams.delete(fromNotification.name);
        setSearchParams(newParams);

        if (typeof options.onSuccess === 'function') {
          options.onSuccess();
        }
      }
    },
  });

  const create = (values) => createMutation.mutateAsync({ values });

  return {
    create,
    loading: createMutation.isLoading,
  };
};
